import { useEffect, useState } from "react";
import Api from "utils/api";

// TODO: Unit Test should be available for this component. There is some work to be done to mock this out appropriately.
export const useAuthFlow = () => {
  const [integration, setIntegration] = useState({});

  const getIntegration = async () => {
    try {
      const { data } = await Api.RENXT_INTEGRATION.INTEGRATION.get();
      setIntegration(data);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleIntegrationClick = async () => {
    const getRedirect = async () => {
      try {
        return await Api.RENXT_INTEGRATION.REDIRECT.get();
      } catch (e) {
        console.log({ e });
      }
    };

    const {
      data: { redirect },
    } = await getRedirect();

    window.location.replace(redirect);
  };

  const handleLogoutClick = () => {
    const { id } = integration;
    const patchIntegration = async ({ id, state }) => {
      try {
        await Api.AUTH.INTEGRATION.patch({
          urlArgs: {
            id,
          },
          data: {
            integration: {
              state,
            },
          },
        });
        getIntegration();
      } catch (e) {
        console.log({ e });
      }
    };

    patchIntegration({ id, state: "disabled" });
  };

  useEffect(() => {
    const searchParams = new URL(window.location).searchParams;
    const authCode = searchParams.get("code");

    if (authCode) {
      const postAuthentication = async ({ authCode }) => {
        try {
          const { status, data } =
            await Api.RENXT_INTEGRATION.AUTHENTICATE.post({
              data: {
                authorization_code: authCode,
              },
            });

          if (status === 200) {
            setIntegration(data);
            window.location.replace(window.location.href.split("?")[0]);
          }
        } catch (e) {
          console.log({ e });
        }
      };

      postAuthentication({ authCode });
    } else {
      getIntegration();
    }
  }, []);

  const { state } = integration;

  return { state, handleIntegrationClick, handleLogoutClick };
};

export default useAuthFlow;
